import { PracticeTemplate } from '@cibo/core'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ApplyTemplateWarningProps {
  open: boolean
  template: PracticeTemplate | null
  onConfirm: () => void
  onCancel: () => void
  isApplying: boolean
  immutableTraitIds?: string[]
}

export const ApplyTemplateWarning = ({
  open,
  template,
  onConfirm,
  onCancel,
  isApplying,
  immutableTraitIds = [],
}: ApplyTemplateWarningProps) => {
  const { t } = useTranslation(['traits', '@cibo/programs/TemplateEditorModal'])

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('applyWarningTitle', { ns: '@cibo/programs/TemplateEditorModal' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('applyWarningMessage', {
            ns: '@cibo/programs/TemplateEditorModal',
            name: template?.name,
          })}
        </DialogContentText>

        {immutableTraitIds.length > 0 && (
          <>
            <DialogContentText sx={{ mt: 2 }}>
              {t('applyWarningImmutableNote', { ns: '@cibo/programs/TemplateEditorModal' })}
            </DialogContentText>
            <List dense disablePadding sx={{ mt: 1 }}>
              {immutableTraitIds.map(traitId => (
                <ListItem key={traitId} disableGutters>
                  <ListItemText primary={t(traitId, { ns: 'traits' })} />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t('cancel', { ns: '@cibo/programs/TemplateEditorModal' })}
        </Button>
        <Button variant="contained" color="primary" loading={isApplying} onClick={onConfirm}>
          {t('applyTemplate', { ns: '@cibo/programs/TemplateEditorModal' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
